export default {
   billing_accounts_id: 'Id',
   billing_accounts_name: 'Name',
   billing_accounts_created_on: 'Created On',
   billing_accounts_created_by: 'Created by',
   billing_accounts_add_new: 'Add Billing Account',
   billing_accounts_updated_on: 'Updated On',
   billing_accounts_updated_by: 'Updated by',
   billing_accounts_created_on: 'Created On',
   billing_accounts_created_by: 'Created by',
   billing_accounts_delete: 'Delete',
   billing_accounts_edit: 'Edit',
   billing_accounts_devices_assigned: 'Devices Assigned',
   billing_accounts_assigned_devices_title: 'Assigned Devices',
   billing_accounts_no_devices: 'No devices found',
};



